module.exports = __webpack_public_path__ + "img/vue.17c52cf8.png";